import styles from './ExamChangeGuidePage.module.scss'
import React, { ReactElement, useCallback } from 'react'
import { ExamChangeGuidePageProps } from '@/components/ExamChangeGuidePage/ExamChangeGuidePage.types'
import { useRouter } from 'next/router'
import Select, { DefaultOptionType } from 'antd/lib/select'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { Spring2023 } from '@/components/ExamChangeGuidePage/ExamChangeInfo/Spring2023'
import { Fall2023 } from '@/components/ExamChangeGuidePage/ExamChangeInfo/Fall2023'
import { Spring2024 } from './ExamChangeInfo/Spring2024'
import { BackToTop } from '@/components/static/BackToTop/BackToTop'
import { Fall2024 } from '@/components/ExamChangeGuidePage/ExamChangeInfo/Fall2024'
import { Spring2025 } from '@/components/ExamChangeGuidePage/ExamChangeInfo/Spring2025'
import { Fall2025 } from '@/components/ExamChangeGuidePage/ExamChangeInfo/Fall2025'
import { Fall2026 } from '@/components/ExamChangeGuidePage/ExamChangeInfo/Fall2026'

export const ExamChangeGuidePage: React.FC<ExamChangeGuidePageProps> = (
    props
): ReactElement => {
    const router = useRouter()
    const handleChange = useCallback(
        async (value: DefaultOptionType | string): Promise<void> => {
            await router.push({
                pathname: UiLayoutConstant.EXAM_CHANGE_GUIDE_PAGE,
                hash: value as string,
            })
        },
        [router]
    )

    return (
        <>
            <BackToTop isLoggedIn={props.isLoggedIn} />

            <div className={styles.examChangeGuidePageBackground}>
                <div className={styles.examChangeGuidePage}>
                    <div className={styles.titleAndSelectBox}>
                        <div className={styles.title}>
                            <h1>Exam Updates</h1>
                        </div>
                        <div className={`${styles.selectorStyles}`}>
                            <Select
                                options={[
                                    {
                                        value: 'fall2026',
                                        label: 'Fall 2026',
                                    },
                                    {
                                        value: 'fall2025',
                                        label: 'Fall 2025',
                                    },
                                    {
                                        value: 'spring2025',
                                        label: 'Spring 2025',
                                    },
                                    {
                                        value: 'fall2024',
                                        label: 'Fall 2024',
                                    },
                                    {
                                        value: 'spring2024',
                                        label: 'Spring 2024',
                                    },
                                    { value: 'fall2023', label: 'Fall 2023' },
                                    {
                                        value: 'spring2023',
                                        label: 'Spring 2023',
                                    },
                                ]}
                                onChange={handleChange}
                                showSearch={true}
                                optionFilterProp={'label'}
                                size={'large'}
                                defaultActiveFirstOption={true}
                                defaultValue={'fall2026'}
                                style={{ minWidth: '150px' }}
                                popupClassName={styles.selectorDropdown}
                            />
                        </div>
                    </div>
                    <Fall2026 key={'fall2026'} />
                    <hr />
                    <Fall2025 key={'fall2025'} />
                    <hr />
                    <Spring2025 key={'spring2025'} />
                    <hr />
                    <Fall2024 key={'fall2024'} />
                    <hr />
                    <Spring2024 key={'spring2024'} />
                    <hr />
                    <Fall2023 key={'fall2023'} />
                    <hr />
                    <Spring2023 key={'spring2023'} />
                </div>
            </div>
        </>
    )
}
